export default __webpack_public_path__ + "media/quickbooks-brand-preferred-logo-50-50-black-external.f9e21.png";